import { Converter } from './Converter';
import { RoomTour } from './RoomTour';

class CapacityChart {
  constructor(select) {
    this.capacityChart = '';
    this.select = select;
    this.defaultDimension = select.getAttribute('data-default-dimension') || 'meters';
    this.currentDimension = this.defaultDimension;
    this.selectValue = select.querySelector('.capacity-chart__select-value');
    this.init();
  }

  init() {
    const toggle = this.select.querySelector('.capacity-chart__select-inner');
    const options = this.select.querySelector('.capacity-chart__options');

    if (toggle) {
      toggle.addEventListener('click', this.handleToggleClick);
    }

    if (options) {
      options.querySelectorAll('.capacity-chart__option').forEach((option) => {
        option.addEventListener('click', this.handleOptionClick);
      });
    }
  }

  handleToggleClick = (e) => {
    e.stopPropagation();
    const isOpen = this.select.classList.toggle('is-open');
    if (isOpen) {
      this.openSelect();
    } else {
      this.setCurrentDimension();
      this.hideSelect();
    }
  };

  handleOutsideClick = (e) => {
    if (!this.select.contains(e.target)) {
      this.setCurrentDimension();
      this.hideSelect();
    }
  };

  handleOptionClick = (e) => {
    const option = e.currentTarget;
    const optionText = option.textContent.trim();

    this.setCurrentDimension(optionText);
    this.hideSelect();
    this.updateTableCells();
  };

  updateTableCells() {
    const wpDataTable = this.getTableBlock();
    if (!wpDataTable) return;

    delete this.capacityChart;

    this.capacityChart = new Converter(wpDataTable, this.defaultDimension, this.currentDimension);
    this.capacityChart.processTable();
  }

  getTableBlock() {
    let el = this.select.nextElementSibling;
    while (el && !el.classList.contains('wpDataTables')) {
      el = el.nextElementSibling;
    }
    return el;
  }

  setCurrentDimension(optionText = '') {
    const options = this.select.querySelectorAll('.capacity-chart__option');
    const selectValue = this.select.querySelector('.capacity-chart__select-value');

    if (optionText) {
      this.currentDimension = optionText;
      selectValue.textContent = optionText;
    } else {
      options.forEach((option) => {
        // eslint-disable-next-line no-param-reassign
        optionText = option.textContent.trim();

        if (this.currentDimension === optionText) {
          selectValue.textContent = optionText;
          option.setAttribute('data-current', 'true');
        } else {
          option.setAttribute('data-current', 'false');
        }
      });
    }
  }

  openSelect() {
    this.selectValue.innerHTML = this.selectValue.getAttribute('data-label');
    setTimeout(() => document.addEventListener('mousedown', this.handleOutsideClick), 0);
  }

  hideSelect() {
    this.select.classList.remove('is-open');
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('.capacity-chart__select');
  if (select) {
    // eslint-disable-next-line no-new
    new CapacityChart(select);
  }

  // eslint-disable-next-line no-new
  new RoomTour();
});
